<template>
  <div class="dataBox">
    <span>您的入会申请正在进行初审，请耐心等待...</span>
  </div>
</template>

<script>
export default {
  name: 'processDataexamine'
}
</script>

<style scoped>
.dataBox{
  padding-top: 180px;
}
.dataBox span{
  font-size: 18px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/joinprocess/processDataexamine.vue